import router from '@/router'
import createRoute from './createRoute'

export default function pushToRoute(props) {
  const route = createRoute(props)
  router.push(
    route
  )
}
